import { render, staticRenderFns } from "./AskAcessModalContent.vue?vue&type=template&id=0a26efd4&scoped=true&"
import script from "./AskAcessModalContent.vue?vue&type=script&lang=js&"
export * from "./AskAcessModalContent.vue?vue&type=script&lang=js&"
import style0 from "./AskAcessModalContent.vue?vue&type=style&index=0&id=0a26efd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a26efd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
